import script from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=3a2229a3&lang=css"

const __exports__ = script;

export default __exports__